var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: _vm.color },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.message) + " "),
          _vm.showButton
            ? _c(
                "v-btn",
                {
                  attrs: { color: "white", text: "" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [_vm._v("Cerrar")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }